import React from "react";

import { BsJustify } from "react-icons/bs";
import { useState } from "react";
import {Link} from 'react-router-dom'
import {BiExit} from "react-icons/bi";
import chauss from './img/Chauss.jpg';




function Ep() {
  const [show, setShow] = useState(false);
  const [isActive, setIsActive] = useState(true);

  return (
    <div class="nsk">
      {/* <div className="icons">
        <BsJustify onClick={() => setShow(!show) ?? setIsActive(!isActive)} />
        </div> */}
        <p></p>
        <div className="alle2" style={{ filter: isActive ? "" : "blur(20px)" }}>
        <b>Чаусский острог </b>
        </div>  
        <p></p>

                 
                    <div> <table>
                        <div class="sv-title">
                           
                        </div>
                        <div class="church-1l-image">
                            <img src={chauss} width={280}
                                alt=""
                                title="" />
                        </div>
                        
                        <div class ={"inf-5"}>
                        Освоение русским народом Сибири началось в конце ХVI в. В начале XVIII в. на территории современной Новосибирской области были построены три острога: Умревинский (1703 г.), Чаусский (1713 г.), Бердский (1715 г.). Остроги строились для обороны южных границ Российского государства от набегов кочевников и как базы для дальнейшего продвижения в Сибирь и на Дальний Восток. Всего в Сибири и на Дальнем Востоке было построено 89 острогов, многие из них стали городами — Тюмень, Омск, 
                        Томск, Иркутск, Красноярск и другие.</div>
                       <div class ={"inf-5_2"}>В июне 1713 г. комендант Томского острога Р. А. Траханиотов поручил дворянину Д. И. Лаврентьеву найти место для острога на реке Чаус. Удобное место было найдено в устье реки Чаус в шести верстах от её впадения в р. Обь, 
                       рядом с деревней Анисимовой.</div>
                       <div class ={"inf-5_2"}>Строительство острога началось 29 июня (12 июля н.ст.) 1713 г. и было закончено 4 (17 н.ст.) сентября того же года. Острог был выстроен четырёхугольным в плане, длиною 50 сажен (около 106 м) и шириною «тридцать сажен печатных» (около 64 м). 
                       Прямоугольная форма считалась наиболее удобной для организации обороны.</div>
                       <div class ={"inf-5_2"}>Острог имел 6 башен, 4 башни располагались по углам и две в стенах с проезжими воротами и запускными решётками. Конструкция башни состояла из 4-угольного сруба и нависающего над ним облама — второго большого сруба в 5–8 венцов, поддерживаемого верхними выступающими венцами брёвен основы башни. Между обламом и основанием башни находился проём шириной 15–25 см. Через него в верхнем этаже башни велось поражение противника, вплотную подошедшего к острожной стене. В стенах башни и обламов просекались бойницы (8–10 см) для стрельбы по неприятелю. Крышей башни являлся шатёр — четырёхскатное пирамидальное покрытие. На проездной башне сооружалась караульная сторожевая вышка. Шатры башен покрывались тесовыми досками. Башни использовались под жильё и амбары. Острог с 5 и более башнями, как правило, сооружался на месте будущих городов. Поэтому дальнейшая судьба Чаусского острога — преобразование его в город Колывань — не случайна. Вокруг острога с трёх сторон был выкопан ров, а с четвёртой протекала речка Чаус. Около рва были устроены рогатки и поставлены надолбы (для противодействия кавалерии противника). В остроге размещалась изба приказчика, судная изба, амбар для хранения боеприпасов, «пять амбаров, в которые принимается с чеусских плательщиков четвериковой провиант да амбар 
                       с казённою продажною солью…».</div>
                        
                        
                       <div class ={"inf-5_2"}>Первые жители острога — казаки — несли военную и государственную службу, а также занимались хозяйствованием и различными промыслами. В 1721 г. 
                       в остроге было 30 казаков, а в 1731 г. — 120.</div>

                       <div class ={"inf-5_2"}>В 1719 г., через шесть лет после возведения укреплённого пункта, в нём была построена деревянная церковь 
                       и поставлены дворы священников.</div>

                       <div class ={"inf-5_2"}>Поставленный для обороны острог так никогда и не подвергался нападениям неприятелей, так как граница Российского государства сместилась южнее и после 1750 г. укрепления Чаусского острога не восстанавливались. Хотя поселение утратило военные функции, жизнь в нём продолжалась. Через острог в конце ХVIII в. прошёл главный тракт Сибири — Московский, острог стал выполнять функцию транспортно-перевалочного пункта на Тарско-Томском участке Московско-Сибирского тракта, по которому шло всё товарное движение. По тракту ежегодно отправлялись миллионы пудов различных грузов, для чего требовалось от 80 до 100 тыс. подвод и 20 тыс. возчиков. Притрактовое положение чаусского поселения делало его центром хозяйственной жизни, здесь стала развиваться торговля, извоз, ремёсла. На крестьян Чаусского ведомства возлагалась обязанность поставлять по очереди или по подряду подводы для почтовой ямской гоньбы. У крестьян Чаусской волости обычным явлением было содержание во дворах десяти и более лошадей, 
                       кроме того, держали коров, свиней, овец.</div>

                       <div class ={"inf-5_2"}>Для дальнейшего развития края необходим был город, и в 1797 г. был «учреждён город Колывань 
                       и назначен из Чаусского острога».</div>

                       <div class ={"inf-5_2"}>В середине ХVIII в. в ведомстве Чаусского острога числилось 48 деревень. В это время крестьяне Чаусского ведомства были основными поставщиками хлеба для Томска, на демидовские заводы Алтая и в крепости по Иртышу. 
                       Успешно развивалось животноводство.</div>
                       
                        <div class ={"inf-5_2"}>В настоящее время Чаус — деревня в Колыванском районе Новосибирской области.</div>

                        

                        <div class ={"inf-5_podpis"}>Материал предоставлен Новосибирской государственной областной научной библиотекой
                         </div>

                       
                         
                        
                        
                          
                        </table>
                        
                          
                    
                    </div>        
      


             
   

      
      <Link to='/sobor'><div class='BiExit'><BiExit /></div></Link>
    </div>
  );
}

export default Ep;
